<template>
  <section>
    <b-row >
      <b-col class="box-effect linear"
        >
            <b-card 
              >   
                <template v-slot:header >
                  <div class="header-card">
                    Archivo Plano de Retiros Afiliados sin Aportes
                  </div> 
                </template> 
                <sw-tableget 
                    :alertClass="tableAlertClass"
                    :alertText="tableAlertText"
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="tableGetRetiros"
                    @filtrar="getFiltrar"
                    @limpiar="getLimpiar"
                    @save="saveForm"
                    >    
                    <template v-slot:filtrar>
                      <b-row style="margin-bottom:5px ;background: rgba(0, 80, 166, 0.03); 
                      ;padding-top:15px;border: 1px ridge;">
                        <b-col :md="4">                                        
                           <b-input-group  class="filter-sw-group" size="sm" prepend="Razón Social">
                            <c-multiselect
                              style="display:inline-block;flex: 1 1 0%"   
                              v-model="filter.id_datos_razon"                   
                              :options="filterSelects('datos_razon')"
                              @input="resetDataGet()"
                              label="name"
                              track-by="name"
                              :preselect-first="false"
                              placeholder="Seleccionar"
                              >
                              </c-multiselect>
                          </b-input-group>             
                        </b-col>        
                        <b-col :md="4">                     
                         <div>         
                            <b-input-group class="filter-sw-group" size="sm" prepend="Periodo:" style="margin-bottom:5px">
                              <c-multiselect
                                style="display:inline-block;flex: 1 1 0%"   
                                v-model="filter.mes_periodo"                   
                                :options="lists.list_mes"
                                @input="resetDataGet()"
                                label="name"
                                track-by="name"
                                :allow-empty="false"
                                :preselect-first="false"
                                placeholder="Mes"
                                >
                              </c-multiselect>
                              <c-multiselect
                                style="display:inline-block;flex: 1 1 0%"   
                                v-model="filter.ano_periodo"                   
                                :options="lists.list_ano"
                                @input="resetDataGet()"
                                label="name"
                                track-by="name"
                                :allow-empty="false"
                                :preselect-first="false"
                                placeholder="Año"
                                >
                              </c-multiselect>
                            </b-input-group> 
                          </div>                 
                        </b-col>
                        <b-col :md="4">                       
                            <b-form-checkbox-group id="checkbox-group-2" size="md" v-model="filter.servicios" name="flavour-2">
                              <b-form-checkbox value="Ccf" @input="resetDataGet()">CCF</b-form-checkbox>
                              <b-form-checkbox value="Afp" @input="resetDataGet()">AFP</b-form-checkbox>
                            </b-form-checkbox-group>
                        </b-col>
                      </b-row>                      
                    </template>     
                      <template v-slot:modal>
                        <sw-modaleditaraportes 
                          v-if="openModal.modal.modal==='Editar'"
                          @save="saveForm"                     
                          >
                        </sw-modaleditaraportes> 
                      </template>   
                </sw-tableget>  
            </b-card>           
      </b-col>      
    </b-row> 
    <b-modal 
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      size="md"  
      >        
        <sw-modalregistrarplanilla 
          v-if="openModal.modal.modal==='Planilla'"
          @save="saveForm"                     
          >
        </sw-modalregistrarplanilla>     
    </b-modal> 
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex"
import indexMix    from './indexMix.js'
import storeMix    from './storeMix.js'
import tableMix    from './tableMix.js'
import saveMix     from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwModalregistrarplanilla from '@/components/modals/registrarPlanilla.vue'
import SwModaleditaraportes from '@/components/modals/editarAportes.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: "afiliacion_informes",
  components: { 
    SwTableget,
    SwSearchs,
    'c-multiselect': Multiselect,
    SwModalregistrarplanilla,
    SwModaleditaraportes
  },
  mixins: [indexMix, storeMix, tableMix, saveMix, saveMixins,],
};
</script>
